<template>
    <div
        class="slt-gsap-milestones mb-[200vh]"
        :style="{
            height:
                milestonesContainerHeight + landscapesContainerHeight + 'px',
        }"
    >
        <div class="fixed top-0 h-screen w-full">
            <!-- 3D Experience -->
            <TresCanvas
                style="pointer-events: none"
                renderMode="on-demand"
                windowSize
                :preset="'flat'"
                :depth="false"
                :precision="'mediump'"
                :premultipliedAlpha="false"
                :preserveDrawingBuffer="false"
                :stencil="false"
                :toneMapping="NoToneMapping"
                :useLegacyLights="false"
                :powerPreference="'high-performance'"
            >
                <!-- FIXME: Stats is temporary for debugging -->
                <!-- <StatsGl /> -->

                <TresPerspectiveCamera
                    :position="configs.cameraPosition"
                    :lookAt="configs.cameraLookAt"
                    :far="850"
                />

                <MoleculesMilestoneExperience
                    :milestones="milestones"
                    :progress="progress"
                />

                <!-- <Stars
                    :position="[0, 0, -10]"
                    :size="0.1"
                    :count="starsCount"
                    :radius="starsRadius"
                /> -->
                <MoleculesStar
                    :position="[0, 0, -10]"
                    :size="0.2"
                    :radius="starsRadius"
                />
                <!-- :count="starsCount" -->
            </TresCanvas>

            <!-- Contents below are reference for canvas html -->
             <!-- TODO: temp hidden-->
            <div class="hidden absolute inset-0 h-0 w-0 overflow-hidden">
                <AtomsTitle3D
                    v-if="shouldRender(milestones?.title)"
                    class="w-fit text-base-white"
                    id="slt-js-milestone-title-0"
                >
                    <span class="text-primary-orange">
                        {{ milestones?.title[0] }}
                    </span>
                    <span>
                        {{ milestones?.title[1] }}
                    </span>
                </AtomsTitle3D>
                <ul
                    v-for="(m, idx) in milestones?.data"
                    :key="idx"
                    class="w-fit"
                >
                    <MoleculesMilestone :milestone="m" :index="idx + 1" />
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { NoToneMapping } from "three";
// import { StatsGl } from "@tresjs/cientos";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { map, shouldRender } from "~/lib/utils";
import { organismMilestonesAnimate } from "@/lib/gsap-about";
import { killAnimation } from "@/lib/gsap-core";
import { getFullTimelineLength } from "~/components/molecules/about/config";

import { useGtag } from "vue-gtag-next";

const { milestones } = defineProps({
    milestones: {
        type: Object,
        required: true,
    },
});
const { configs, handleResize } = useExperience();
const { setHeaderMode } = useMode();
const { event } = useGtag();

const milestonesContainerHeight = ref(5000);
const landscapesContainerHeight = ref(3000);
const progress = ref(0);
const starsCount = ref(50);
const starsRadius = ref(300);

const updateContainerHeight = () => {
    handleResize();
    const windowScale = map(window.innerWidth, 1920, 393, 4, 3);
    milestonesContainerHeight.value = getFullTimelineLength() * windowScale;
    landscapesContainerHeight.value =
        document.querySelector(".slt-gsap-landscapes")?.clientHeight ?? 0;

    nextTick(ScrollTrigger.refresh);
};

let tl = null;
onMounted(() => {
    updateContainerHeight();
    window.addEventListener("resize", updateContainerHeight);
    tl = organismMilestonesAnimate(
        progress,
        milestonesContainerHeight,
        starsCount,
        starsRadius,
        () =>
            event("user_engagement", {
                event_category: "about",
                event_label: "里程碑",
            }),
    );

    watch(progress, (newVal) => {
        if (newVal < 1) setHeaderMode(newVal > 0.1 ? "dark" : "silver");
    });
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", updateContainerHeight);
    killAnimation(tl);
});
</script>
